<template>
	<div class="Delivery">
		<common-body aside="5">
			<div slot="commonMain" class="offer_box">
				<div class="lq-toolbar offer_header">
					<el-input
						v-model="search"
						class="lq-search"
						clearable
						prefix-icon="el-icon-search"
						placeholder="搜索单号 / 订货方 / 联系人 / 物流"
						@keyup.enter.native="searchList"
						@clear="searchList" />
					<el-date-picker
						class="lq-date header_date"
						value-format="timestamp"
						:editable="editable"
						unlink-panels
						size="small"
						@change="getDate"
						v-model="dateTime"
						type="daterange"
						range-separator="-"
						start-placeholder="开始日期"
						end-placeholder="结束日期" />
					<div class="lq-toolbar-actions">
						<el-button type="primary" size="small" @click="searchList">查询</el-button>
						<el-button size="small" @click="delSearch">清空</el-button>
					</div>
				</div>
				<div v-if="categoryName" class="lq-category-hint">当前分类：{{ categoryName }}</div>
				<el-table ref="listTable" stripe class="lq-table lq-table--clickable" :data="list" style="width: 100%" cell-class-name="good_text" header-cell-class-name="good_header" @row-dblclick="handleRowDblClick">
					<el-table-column align="center" width="64" label="序号" class-name="lq-index-col" header-align="center">
						<template slot-scope="scope">
							<div>{{scope.$index+1}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="108" prop="order_number" label="单号" show-overflow-tooltip>
						<template slot-scope="scope">
							<span
								class="lq-order-no"
								:class="{ 'lq-order-no--after-sales': isAfterSalesRow(scope.row) }">
								{{ scope.row.order_number }}
							</span>
							<div v-if="scope.row.sample_deduct_text" class="sample-deduct-tag">{{ scope.row.sample_deduct_text }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="108" prop="customer_id" label="订货方" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" min-width="80" prop="contacts" label="联系人" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" min-width="80" prop="delivery_text" label="运输方式" show-overflow-tooltip>
					</el-table-column>
					<el-table-column align="center" min-width="120" prop="order_sn" label="物流单号" show-overflow-tooltip>
						<template slot-scope="scope">
							<div>{{scope.row.order_sn==""?"无":scope.row.order_sn}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="80" prop="deliver" label="发货人" show-overflow-tooltip>
						<template slot-scope="scope">
							<div>{{scope.row.deliver&&scope.row.deliver!=""?scope.row.deliver:"无"}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="96" prop="createTime" label="录入日期">
					</el-table-column>
					<el-table-column align="center" width="48" label="状态" class-name="lq-ship-status-col" header-align="center">
						<template slot="header">
							<el-tooltip content="发货状态" placement="top" :open-delay="300">
								<span class="lq-ship-status-head">状态</span>
							</el-tooltip>
						</template>
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.status_text" placement="top" :open-delay="300">
								<div class="lq-ship-status-cell">
									<i
										:class="shipStatusIconClass(scope.row.status)"
										aria-hidden="true"></i>
								</div>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column align="left" min-width="160" label="备注" class-name="lq-remarks-col" header-align="center">
						<template slot-scope="scope">
							<lq-remarks-cell :text="remarksContent(scope.row)" empty-text="无" />
						</template>
					</el-table-column>
					<el-table-column align="center" width="112" label="操作" fixed="right" class-name="lq-action-col" header-align="center">
						<template slot-scope="scope">
							<div v-if="!ruleList.deliver_goods_see&&!ruleList.deliver_goods_del"></div>
							<div v-else class="lq-row-actions">
								<el-tooltip v-if="ruleList.deliver_goods_see" content="查看详情" placement="top">
									<el-button type="text" icon="el-icon-view" class="lq-row-action-btn" @click="showDetail(scope.$index)" />
								</el-tooltip>
								<el-popconfirm v-if="ruleList.deliver_goods_del" @confirm="delList(scope.$index)" confirmButtonType="danger" confirmButtonText="删除" title="确定删除这一单吗？">
									<el-tooltip content="删除" placement="top" slot="reference">
										<el-button type="text" icon="el-icon-delete" class="lq-row-action-btn lq-row-action-btn--danger" @click.stop />
									</el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination class="good_page" :hide-on-single-page="pageSingle" @current-change="changePage" :page-size="limit"
				 prev-text="上一页" next-text="下一页" background layout="prev, pager, next" :total="listTotal">
				</el-pagination>
			</div>
		</common-body>
	</div>
</template>

<script>
	import {
		getT
	} from "../assets/js/public.js"
	import {
		fetchQuotationCategory
	} from "../utils/quotation-category.js"
	export default {
		name: 'Delivery',
		data() {
			return {
				categoryId: 0,
				categoryName: '',
				categoryWarned: !1,
				skipNextActivated: !0,
				ruleList: JSON.parse(localStorage.getItem('ruleList')),
				editable: !1,
				search: '',
				page: 1,
				pageSingle: !1,
				limit: 10,
				listTotal: 0,
				list: [],
				dateTime: '',
				stime: '',
				etime: ''
			}
		},
		created() {
			this.reload();
		},
		activated() {
			if (this.skipNextActivated) {
				this.skipNextActivated = !1
				return
			}
			this.reload();
		},
		beforeRouteLeave(to,from,next) {
			from.meta.keepAlive = !1
			next()
		},
		methods: {
			isAfterSalesRow(row) {
				return !!(row && String(row.pay_status) === '3')
			},
			remarksContent(row) {
				const text = row && row.remarks != null ? String(row.remarks).trim() : '';
				return text;
			},
			shipStatusIconClass(status) {
				const shipped = String(status) === '2';
				return [
					'lq-ship-status-icon',
					shipped ? 'el-icon-circle-check good_pay2' : 'el-icon-time good_pay1'
				];
			},
			reload() {
				let that = this
				fetchQuotationCategory(that.$fetch.bind(that)).then(function(info) {
					that.categoryId = info.categoryId
					that.categoryName = info.categoryName || ''
					that.page = 1
					that.getList()
				})
			},
			getList(e) {
				let that = this
				if (!that.categoryId) {
					that.list = []
					that.listTotal = 0
					that.layoutTable()
					if (!that.categoryWarned) {
						that.categoryWarned = !0
						that.$message({
							message: '请先在产品列表选择产品分类',
							center: !0,
							type: 'warning',
							duration: 1500
						})
					}
					return
				}
				that.$fetch('addons/hlm/api.Order/orderList', {
					page: that.page,
					limit: that.limit,
					search: that.search,
					type: that.categoryId,
					stime: that.stime,
					etime: that.etime,
					place_order_status: '2',
					include_shipped: 1
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						let list = res.data.list
						list.forEach((item, index) => {
							item.createTime = getT(item.createtime * 1000)
						})
						that.list = list, that.listTotal = res.data.total
						that.layoutTable()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			layoutTable() {
				this.$nextTick(() => {
					const table = this.$refs.listTable
					if (table && table.doLayout) table.doLayout()
				})
			},
			getDate(e){
				if (!e || !e[0] || !e[1]) {
					this.stime = ''
					this.etime = ''
					return
				}
				let that = this
				that.stime = e[0]/1000,that.etime = e[1]/1000				
				if(e[1]/1000<e[0]/1000) that.stime = e[1]/1000,that.etime = e[0]/1000
			},
			changePage(e) {
				let that = this
				that.page = e, that.getList()
			},
			searchList() {
				this.page = 1
				this.getList()
			},
			delSearch(){
				this.search = ""
				this.dateTime = ""
				this.etime = ""
				this.stime = ""
				this.page = 1
				this.getList()
			},
			showDetail(e) {
				let that = this,id = that.list[e].id
				that.$router.push(`/deliveryDetail?id=${id}`)
			},
			handleRowDblClick(row) {
				if (!this.ruleList.deliver_goods_see) return
				const index = this.list.findIndex((item) => item.id === row.id)
				if (index >= 0) this.showDetail(index)
			},
			delList(e){
				let that = this,
					id = that.list[e].id
				that.$fetch('addons/hlm/api.order/del', {
					id: id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.detailStatus = !1, that.$message({
							message: '删除成功',
							type: 'success',
							duration: 1500,
							center: !0,
							onClose() {
				
							}
						}), that.getList()
					}
				}).catch(function(error) {
					console.log(error)
				})
			}
		}
	};
</script>

<style src='../assets/css/delivery.css'>
	/* px2rem能正常转换 */
</style>
